import React, { useState, useRef } from 'react'
import MenuIcon from '../components/MenuIcon'
import Sidebar from './Sidebar'

const Header = () => {
    const [activeMenuText, setActiveMenuText] = useState('Piva');
    const menuIconRef = useRef();

    const setActiveMenuLabel = (text) => {
        setActiveMenuText(text);
        // Simulate icon click so the opened sidebar closes
        menuIconRef.current.click();
    }

    return (
        <header className="fixed-top">
            <div 
                id="toolbar" 
                className="row no-wrap items-center justify-between q-pt-md"
            >
                <img src="/assets/img/logo.png" loading="eager" className="logo" alt="" />

                <MenuIcon ref={menuIconRef} activeText={activeMenuText} />
                <Sidebar setActiveMenuLabel={setActiveMenuLabel} />
            </div>
        </header>
    )
}

export default Header